import { GenericObject, Locale, LocalizedString, copyFields } from '@synergy/models';
import stripTags from 'striptags';

import { Product } from './product';

export class ProductSnapshot {
    public id?: number;
    public currency?: string;
    public isBestPrice!: boolean;
    public isNormArticle?: boolean;
    public name!: LocalizedString;
    public price?: number;
    public product?: Product;
    public productNumber?: string;
    public quantity!: number;
    public orderUnit!: string;
    public tax?: number;
    public supplierAccountId!: number;
    public supplierAccountName!: string;
    public discount?: number;
    public contentQuantity?: number;
    public contentQuantityPrice?: number;
    public contentUnit?: string;

    public shortDescription?: LocalizedString;
    public longDescription?: LocalizedString;

    public static fromPlainObject(object: GenericObject): ProductSnapshot {
        const productSnapshot = new ProductSnapshot();

        copyFields(object, productSnapshot);

        if (object['product']) {
            productSnapshot.product = Product.fromPlainObject(object['product']);
        }

        if (productSnapshot.longDescription) {
            Object.keys(productSnapshot.longDescription)
                .map(key => key as Locale)
                .forEach(key => {
                    if (productSnapshot.longDescription?.[key]) {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        productSnapshot.longDescription[key] = stripTags(productSnapshot.longDescription[key]!);
                    }
                });
        }

        return productSnapshot;
    }

    public getDescription(): LocalizedString | undefined {
        return this.shortDescription || this.longDescription;
    }
}
